import { QueryOptions } from '@tanstack/react-query';
import { listClusters, listStores } from '../../../../../../../components/FilterSection/services';
import { api } from '../../../../../../../lib';
import { Segment } from '../../../../../../../reducers/gerenciadorPrecos/segmentos';
import { getCattegories } from '../../../../../../../services/ProdutoService_ts';
import { data, parseEnumeratedSegments } from '../../../RegrasDePreco/lib';
import { getRegisterLimitModel } from '../../lib/data';

export async function listCattegoryData(): Promise<Segment[]> {
  const segments = await getCattegories();
  const numeratedSegments = parseEnumeratedSegments(segments);
  return [
    ...numeratedSegments,
    {
      level: 0,
      field: 'productIds',
      value: 'productIds',
      name: 'Produto',
      label: 'Produto',
    },
  ];
}

export async function listStoreData(): Promise<DataItem[]> {
  return await new Promise<DataItem[]>(resolve => {
    resolve(data.storeType);
  });
}

export function listStoreTypeDataQuery(): QueryOptions<DataItem[]> {
  return {
    queryKey: ['ipa.strategy.limits.register.storeType'],
    queryFn: listStoreData,
    initialData: [],
  };
}

export function listStoreDataQuery(query = ''): QueryOptions<DataItem[]> {
  return {
    queryKey: ['ipa.strategy.limits.register.store', query],
    queryFn: () => listStores(query),
    initialData: [],
  };
}

export function listClusterDataQuery(query = ''): QueryOptions<DataItem[]> {
  return {
    queryKey: ['ipa.strategy.limits.register.cluster', query],
    queryFn: () => listClusters(query),
    initialData: [],
  };
}

export async function listSegmentTypeData(): Promise<DataItem[]> {
  return await new Promise<DataItem[]>(resolve => {
    resolve(data.segmentsType);
  });
}

export function listSegmentTypeDataQuery(): QueryOptions<DataItem[]> {
  return {
    queryKey: ['ipa.strategy.limits.register.segmentType'],
    queryFn: listSegmentTypeData,
    initialData: [],
  };
}

export async function saveLimit(data: ReturnType<typeof getRegisterLimitModel>) {
  const response = await api.post('/limits', data, { expectToken: true });
  return response;
}
